import { translate } from './translate';

export const renderContent = (value) => value || translate('common.content-empty');
